<template>
    <div i='components_cart'>
        <el-dialog :custom-class="$store.state.app.cart_type === 4 ? 'sty': ''" :visible.sync="$store.state.app.cart_popup" size="tiny" :title="title" :close-on-click-modal="false" :before-close="close">
            <!-- $store.state.app.cart_type === 4 -->
            <template v-if="false">
                <textarea class="textarea" v-model.trim="content" placeholder=""></textarea>
                <p style="color: #999;" class="mt20">暂不支持线上购买版权，请留下您的联系方式，我们会尽快联系您</p>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button class="btn" type="primary" @click="sub()">确 定</el-button>
                </div>
            </template>
            <template v-else>
                <div class="text-left pl100">
                    <div class="mt20 mb20 mt20">
                        <label @click="$store.state.app.cart_type = 1">
                            <div class="check-chout">
                                <span class="active-chouk" v-if="$store.state.app.cart_type === 1"></span>
                                <span class="chouk" v-else></span>
                            </div>
                            <span>购买版权</span>
                        </label>
                    </div>
                    <div class="">
                        <label @click="$store.state.app.cart_type = 2">
                            <div class="check-chout">
                                <span class="active-chouk" v-if="$store.state.app.cart_type === 2"></span>
                                <span class="chouk" v-else></span>
                            </div>
                            <span>购买实物</span>
                        </label>
                    </div>
                    <div class="mt20">
                        <label @click="$store.state.app.cart_type = 3">
                            <div class="check-chout">
                                <span class="active-chouk" v-if="$store.state.app.cart_type === 3"></span>
                                <span class="chouk" v-else></span>
                            </div>
                            <span>购买版权+实物</span>
                        </label>
                    </div>
                </div>
                
                <div slot="footer" class="dialog-footer text-center">
                    <el-button class="btn" type="primary" @click="submit()">确 定</el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>
<style rel='stylesheet/scss' lang='scss'>
    @import '~sass/common/tool';

    [i="components_cart"]{

        .sty .el-dialog__body{
            padding-bottom: 10px;
        }

        .alert-name{
            text-align: center;
            font-size: 24px;
            color: #333333;
            margin-bottom: 32px;
        }
        .textarea{
            width: 100%;
            max-width: 100%;
            min-height: 400px;
            padding: 10px;
            border-color: #ccc;
        }
        .dialog-footer .btn{
            width: 150px;
        }

        .btn{
            width: 150px;
        }

        .check-chout {
            display: inline-flex;
            align-items: center;
            vertical-align: middle;
            .chouk {
                display: inline-block;
                width: 20px;
                height: 20px;
                background: #FFFFFF;
                border: 1px solid #cbcbcb;
                margin-right: 19px;
                cursor: pointer;
            }
            .active-chouk {
                width: 20px;
                height: 20px;
                background: #02aaf7;
                background-image: url(/static/images/gou.png);
                background-position: center;
                background-repeat: no-repeat;
                background-size: 12px 12px;
                margin-right: 19px;
            }
            .chout-text {
                font-size: 14px;
                color: #333333;
            }
        }
    }
</style>
<script>
    import Vue from 'vue';
	import { Dialog, Button } from 'element-ui';
	Vue.use(Dialog);
	Vue.use(Button);

    export default{
        data(){
            return {
                title: '购买类别',
                content: ''
            }
        },
        props: [],
        created() {

        },
        computed: {
            
        },
        methods: {
            submit() {
				let that = this;

                // if (that.$store.state.app.cart_type === 1) {
                //     that.$store.state.app.cart_type = 4;
                //     that.title = "购买留言"
                //     return;
                // }

				tools.ajax({
					url: '/api/gallery/designer/carts',
					ajaxData: {
						gallery_goods_id: that.$store.state.app.cart_data.id,
						sale_type: that.$store.state.app.cart_type
					},
					isLoading: true,
					successFun: function (res) {
                        that.close();
						that.$store.commit('GET_CART_NUM');
						tools.alert.success('成功加入购物车');
					},
					errorFun: function (error_data, status, headers, error_obj) {
						tools.alert.error(error_data.error_msg);
					},
					type: 'POST'
				});
            },

            close(done) {
                this.$store.state.app.cart_popup = false;
                this.$store.state.app.cart_type = 0;
            },
            
            sub() {
                let that = this;

                if (that.content === '') {
					tools.alert.error('请填写留言');
					return
				}

				tools.ajax({
					url: '/api/gallery/designer/message',
					ajaxData: {
						content: that.content
					},
					isLoading: true,
					successFun: function (res) {
						tools.alert.success('留言成功');
                        that.close();
					},
					errorFun: function (error_data, status, headers, error_obj) {
						tools.alert.error(error_data.error_msg);
					},
					type: 'POST'
				});
            }
        },
        watch: {

        },
        components: {

        },
        filters: {

        },
        mounted() {
            let that = this;
            if (that.$store.state.app.cart_type === 4) {
                that.title = "购买留言";
            }
        },
        destroyed() {

        }
    }
</script>


// WEBPACK FOOTER //
// addCart.vue?bf78ea88